
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clientapp/auth/register",
      function () {
        return require("private-next-pages/clientapp/auth/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clientapp/auth/register"])
      });
    }
  